/*
Monotype Foundry Platform API
Version 1.0.0

Definition: TempImportVersion

Properties:
  tempImportVersion: string (required)
*/

var TempImportVersion = (function () {
  function validateTempImportVersion (arg) {
    // Validate tempImportVersion
    if (!arg.tempImportVersion) {
      throw new Error('TempImportVersion.tempImportVersion: Missing property')
    }
    if (arg.tempImportVersion && !(typeof arg.tempImportVersion === 'string')) {
      throw new Error('TempImportVersion.tempImportVersion: Wrong type: Got \'' + (typeof arg.tempImportVersion) + '\', but expected: \'string\'')
    }
  }
  function buildTempImportVersion (arg) {
    var TempImportVersion = arg
    // Complete tempImportVersion
    // Expected Type: string
    TempImportVersion.tempImportVersion = TempImportVersion.tempImportVersion || ''
    return TempImportVersion
  }
  return {
    validate: validateTempImportVersion,
    build: buildTempImportVersion
  }
})()

module.exports = TempImportVersion
